import { useCallback } from 'react';
import { getPromoErrorMessage, isPromoApiSuccess } from '../../services/promoSurfacesApi';
import { promoFailureMessage } from './promoSurfacesUtils';

export function usePromoSurfacesSession(setError) {
  const handleApiResponse = useCallback(
    (res, fallback) => {
      if (!isPromoApiSuccess(res)) {
        setError(promoFailureMessage(res) || getPromoErrorMessage(res, fallback));
        return true;
      }
      return false;
    },
    [setError]
  );

  return { handleApiResponse };
}
